import SettingsFundsManagers from './SettingsFundsManagers'

export default SettingsFundsManagers
